export var KafkaOffsetStrategy;
(function (KafkaOffsetStrategy) {
    KafkaOffsetStrategy["KAFKA_OFFSET_STRATEGY_EARLIEST"] = "earliest";
    KafkaOffsetStrategy["KAFKA_OFFSET_STRATEGY_LATEST"] = "latest";
    KafkaOffsetStrategy["KAFKA_OFFSET_STRATEGY_FROM_OFFSET"] = "from_offset";
})(KafkaOffsetStrategy || (KafkaOffsetStrategy = {}));
